import type { QueryClient } from '@tanstack/react-query';
import type { AccessInvite } from './api';

export const ACCESS_INVITES_QUERY_KEY = ['access-invites'] as const;

/** Patch one invite row in the shared access-invites cache (instant UI update). */
export function patchAccessInviteInCache(
  queryClient: QueryClient,
  accessInviteId: string,
  patch: Partial<AccessInvite>,
): void {
  queryClient.setQueryData<AccessInvite[]>(ACCESS_INVITES_QUERY_KEY, (current) => {
    if (!current) return current;
    return current.map((invite) =>
      invite.access_invite_id === accessInviteId ? { ...invite, ...patch } : invite,
    );
  });
}
